/**
 * Copyright 2025 Google LLC. This software is provided as-is, without warranty 
 * or representation for any use or purpose. Your use of it is subject to your 
 * agreement with Google.
 */
import { Component, ViewChild } from '@angular/core';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { GuidelinesComponent } from '../guidelines/guidelines.component';
import { BreakpointObserver } from '@angular/cdk/layout';
@Component({
  selector: 'app-home',
  standalone: true,
  imports: [MatSidenavModule, GuidelinesComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  isMobileView = false;
  @ViewChild(MatSidenav)
  sideNav!: MatSidenav;
  constructor(public responsive: BreakpointObserver) {}

  ngOnInit() {
    this.responsive.observe(['(max-width : 768px)'])
      .subscribe(result => {
        this.isMobileView = false;
        if (result.matches) {
          // this.sideNav.mode = 'over';
          // this.sideNav.close();
          this.isMobileView = true;
        } else {
          // if (this.sideNav) {
          //   this.sideNav.mode = 'side';
          //   this.sideNav.open();
          //   console.log(
          //     'HandsetPortrait is on'
          //   );
          // }
        }
      });
  }
}
